"use strict";
/**
 * Basic GameModTransitionController with the addition of a view and basic animation flow already setup.
 *
 * Created: 2019-07-30
 * @author jonas
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameModeTransitionControllerWithView = void 0;
const gsap_1 = require("gsap");
const GameModeTransitionController_1 = require("./GameModeTransitionController");
class GameModeTransitionControllerWithView extends GameModeTransitionController_1.GameModeTransitionController {
    constructor(fromMode, toMode, view) {
        super(fromMode, toMode);
        this._view = view;
    }
    start() {
        if (this.isTriggeredThisSpin) {
            this._view.prepare(this._serverData);
            const tl = new gsap_1.TimelineLite();
            tl.add(this._view.getStartAnimation(() => this.prepareToEnterMode(), () => this.finish()));
        }
        else {
            super.start();
        }
    }
    finish() {
        const tl = new gsap_1.TimelineLite();
        tl.add(this._view.getEndAnimation());
        tl.add(() => super.finish());
    }
}
exports.GameModeTransitionControllerWithView = GameModeTransitionControllerWithView;
//# sourceMappingURL=GameModeTransitionControllerWithView.js.map